import {
    Button,
    Checkbox,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Form,
    Input,
    Row,
    theme,
    Typography,
} from 'antd'
import React, { useMemo, useState } from 'react'
import { ExpandIcon, ToolsIcon } from '../../../assets/icons'
import { profileState } from '../../profile/profile.slice'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { candidateById, candidateEdit } from '../store/candidate.slice'
import EmbeddedChipsInput from '../../../components/ChipsInput/chipsInput'

const ProjectForm = ({
    onCancel,
    currantData,
    activeTab,
    candidateId,
    preProjectData,
}) => {
    const { useToken } = theme
    const { Text, Title } = Typography
    const { token } = useToken()
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [technologies, setTechnologies] = useState([])
    const [checked, setChecked] = useState(false)

    const { formButtonType } = useSelector(profileState)

    const { TextArea } = Input

    const initialValues = useMemo(() => {
        if (!currantData) {
            return {
                name: '',
                startDate: null,
                endDate: null,
                tools: [],
                description: '',
            }
        }

        return {
            name: currantData?.name ? currantData.name : '',
            startDate: currantData?.startDate
                ? dayjs(currantData.startDate)
                : null,
            endDate: currantData?.endDate ? dayjs(currantData.endDate) : null,
            description: currantData.description ? currantData.description : '',
            currentWorking: currantData.currentWorking,
            tools:
                currantData?.technologies?.length > 0
                    ? currantData?.technologies.map((data) => {
                        return {
                            label: data?.name,
                            value: data?._id,
                            logo: data?.logo,
                        }
                    })
                    : [],
        }
    }, [currantData])

    useMemo(() => {
        if (currantData) {
            setTechnologies(currantData?.technologies)
            if (currantData?.currentWorking) {
                setChecked(true)
            }
        }
    }, [currantData])

    const formatDatePicker = (value) => {
        return `${dayjs(value).format('DD MMM YY')}`
    }

    // DISABLE START DATE
    const disabledDateStart = (current) => {
        const endDate = form.getFieldValue('endDate')
        // Disable dates that are after the selected end date or dates that are in the future
        return (
            (endDate && current && current.valueOf() > endDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
        )
    }
    // DISABLE END DATE

    const disabledDateEnd = (current) => {
        const startDate = form.getFieldValue('startDate')
        // Disable dates that are before the selected start date or dates that are in the past
        return startDate
            ? (current && current.valueOf() < startDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
            : current && current.valueOf() > Date.now()
    }
    // COLLAPSE MENU HEADER
    const CollapseLabel = ({ name, icon, description }) => (
        <Row
            align={'middle'}
            style={{
                columnGap: '20px',
                marginBottom: '18px',
                rowGap: "10px"
            }}
        >
            <Row
                style={{
                    height: '50px',
                    width: '50px',
                    borderRadius: '10px',
                    padding: '12px',
                    backgroundColor: token.colorPalette.baseColor.tertiary,
                }}
                align={'middle'}
                justify={'center'}
            >
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px',
                    }}
                >
                    {icon}
                </div>
            </Row>
            <div>
                <Title
                    style={{
                        // fontSize: token.fontSizeHeading4,
                        fontSize: '18px',
                    }}
                >
                    {name}
                </Title>
                <Text className="sub-title" style={{ fontSize: '15px' }}>
                    {description}
                </Text>
            </div>
        </Row>
    )

    const handleCreateEducation = async (edit) => {
        try {
            const values = await form.validateFields()
            const newEducationEntry = {
                attachments: values.attachments || null,
                name: values?.name,
                // technologies: extractValue(values.tools),
                technologies: technologies,
                startDate: values.startDate?.valueOf() || null,
                endDate: values.endDate?.valueOf() || null,
                links: values?.links || null,
                description: values.description || null,
                currentWorking: values?.currentWorking || null,
            }

            let payload = {}

            if (edit) {
                // Only send edited entry
                const existingEducation = preProjectData?.projects || []
                const filteredEducation = existingEducation.filter(
                    (edu) => edu._id !== currantData?._id
                )

                payload = {
                    projects: [...filteredEducation, newEducationEntry],
                    candidateId: candidateId,
                }
            } else {
                // Append new entry to existing education array
                const existingEducation = preProjectData?.projects || []
                payload = {
                    projects: [...existingEducation, newEducationEntry],
                    candidateId: candidateId,
                }
            }

            const { data } = await candidateEdit(
                activeTab,
                candidateId,
                payload
            )
            if (data?.success) {
                dispatch(candidateById({ id: data?.data?._id, activeTab }))
                onCancel(false)
            }
        } catch (error) {
            console.log('🚀 ~ handleCreateEducation ~ error:', error)
        }
    }

    // COLLAPSE ITEMS
    const getItems = () => [
        {
            key: '1',
            label: (
                <CollapseLabel
                    name={`Add Technologies`}
                    icon={
                        <ToolsIcon color={token.colorPalette.baseColor.white} />
                    }
                    description="Please add technologies suitable to your hands-on experience."
                />
            ),
            children: (
                <>
                    <EmbeddedChipsInput
                        value={technologies}
                        onChange={(value) => setTechnologies(value)}
                        title={"Technologies"}
                        placeholder={"Enter Technologies"}
                    />
                </>
            ),
        },
    ]

    return (
        <div>
            <div>
                <Form
                    labelCol={{
                        style: {
                            padding: '0 0 3px',
                        },
                    }}
                    layout="vertical"
                    initialValues={initialValues}
                    name="addEducation"
                    // onFinish={onFinishEducation}
                    // onFinishFailed={onFinishFailed}
                    requiredMark={true}
                    // onSubmitCapture={async (e) => {
                    //     await dispatch(checkButtonType(e.nativeEvent.submitter.id))
                    // }}
                    form={form}
                    style={{
                        marginBottom: '20px',
                        // overflowX: 'hidden',
                    }}
                >
                    <Row
                        style={{
                            rowGap: '20px',
                        }}
                        justify={'space-between'}
                        gutter={16}
                    >
                        <Col span={24}>
                            <Form.Item
                                label="Project Name"
                                name="name"
                                rules={
                                    formButtonType !== 'draftButtonLoading'
                                        ? [
                                            {
                                                required: true,
                                                message: 'Please Enter Title',
                                            },
                                            {
                                                max: 50,
                                                message:
                                                    'Title should be maximum 50 characters long',
                                            },
                                        ]
                                        : []
                                }
                                colon={false}
                            >
                                <Input
                                    name="name"
                                    placeholder="Enter Title"
                                    onChange={(e) => {
                                        form.setFieldValue(
                                            'name',
                                            e.target.value.trimStart()
                                        )
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="Start Date"
                                colon={false}
                                name={'startDate'}
                                rules={
                                    formButtonType !== 'draftButtonLoading'
                                        ? [
                                            {
                                                required: true,
                                                message:
                                                    'Please Select Start Date',
                                            },
                                        ]
                                        : []
                                }
                            >
                                <DatePicker
                                    allowClear={false}
                                    name="start"
                                    disabledDate={disabledDateStart}
                                    format={formatDatePicker}
                                    // getPopupContainer={(trigger) =>
                                    //     trigger.parentNode
                                    // }
                                    getPopupContainer={() => document.body}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="End Date"
                                colon={false}
                                name={'endDate'}
                                rules={
                                    formButtonType !== 'draftButtonLoading' &&
                                        !checked
                                        ? [
                                            {
                                                required: true,
                                                message:
                                                    'Please Select End Date',
                                            },
                                        ]
                                        : []
                                }
                            >
                                <DatePicker
                                    allowClear={false}
                                    disabled={checked}
                                    disabledDate={disabledDateEnd}
                                    name="end"
                                    format={formatDatePicker}
                                    // getPopupContainer={(trigger) =>
                                    //     trigger.parentNode
                                    // }
                                    getPopupContainer={() => document.body}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="Description"
                                name="description"
                                rules={
                                    formButtonType !== 'draftButtonLoading'
                                        ? [
                                            {
                                                required: true,
                                                message:
                                                    'Please Enter Description',
                                            },
                                            {
                                                min: 8,
                                                max: 250,
                                                message:
                                                    'Description is minimum 8 and maximum 250 characters long',
                                            },
                                        ]
                                        : []
                                }
                                colon={false}
                            >
                                <TextArea
                                    rows={4}
                                    placeholder={'Enter Description...'}
                                    name={'summary'}
                                    onChange={(e) => {
                                        form.setFieldValue(
                                            'summary',
                                            e.target.value.trimStart()
                                        )
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                name="currentWorking"
                                valuePropName="checked"
                                rules={
                                    formButtonType !== 'draftButtonLoading' &&
                                        !checked
                                        ? [
                                            {
                                                required: false,
                                                message:
                                                    'Please Select End Date',
                                            },
                                        ]
                                        : []
                                }
                            >
                                <Checkbox
                                    onChange={(e) => {
                                        setChecked(e.target.checked)
                                        if (e.target.checked === true) {
                                            form.setFields([
                                                {
                                                    name: 'endDate',
                                                    errors: [],
                                                },
                                            ])
                                        }
                                        form.setFieldValue('endDate', '')
                                    }}
                                >
                                    I currently Working
                                </Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <Collapse
                        bordered={false}
                        defaultActiveKey={['1', '2']}
                        expandIcon={({ isActive }) => {
                            return <ExpandIcon isActive={!isActive} />
                        }}
                        expandIconPosition="right"
                        style={{
                            backgroundColor: 'transparent',
                        }}
                        items={getItems()}
                    />
                    <Divider style={{ marginTop: '0px' }} />
                    <div
                        style={{
                            marginTop: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                        }}
                    >
                        <Button
                            variant="outlined"
                            style={{ marginRight: "10px", color: "#000", backgroundColor: "transparent", border: "1px solid #d9d9d9" }}
                            color="default"
                            onClick={() => onCancel(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginLeft: '12px' }}
                            onClick={() =>
                                currantData
                                    ? handleCreateEducation('edit')
                                    : handleCreateEducation()
                            }
                        >
                            {currantData ? 'Save Change' : ' Add'}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default ProjectForm
